import { render } from "./TripCopyModal.vue?vue&type=template&id=04b19b25"
import script from "./TripCopyModal.vue?vue&type=script&lang=js"
export * from "./TripCopyModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__